var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _circle4, _circle5, _circle6, _path7, _path8, _path9, _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquatting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 146,
    viewBox: "0 0 268 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 90C110.699 90 91 70.3005 91 46C91 21.6995 110.699 2 135 2C159.301 2 179 21.6995 179 46C179 70.3005 159.301 90 135 90Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156 116C129.49 116 108 94.5097 108 68C108 41.4903 129.49 20 156 20C182.51 20 204 41.4903 204 68C204 94.5097 182.51 116 156 116Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143 146C116.49 146 95 124.51 95 98C95 71.4903 116.49 50 143 50C169.51 50 191 71.4903 191 98C191 124.51 169.51 146 143 146Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89C72.1177 89 56 72.8823 56 53C56 33.1177 72.1177 17 92 17C111.882 17 128 33.1177 128 53C128 72.8823 111.882 89 92 89Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106 134C81.6995 134 62 114.301 62 90C62 65.6995 81.6995 46 106 46C130.301 46 150 65.6995 150 90C150 114.301 130.301 134 106 134Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 249 61)",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 6 74)",
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 39 138)",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 129.5L27 124",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 29 2)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 203 5)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 258 143)",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M222 31.5L240 26.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 41L31 44.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5 107L266 110",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_8333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135 130C163.719 130 187 106.719 187 78C187 49.2812 163.719 26 135 26C106.281 26 83 49.2812 83 78C83 106.719 106.281 130 135 130Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 54,
    r: 6,
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 66H129",
    stroke: "#24284E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 66L121 85",
    stroke: "#24284E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 66L125 85",
    stroke: "#24284E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 85H139.5L131 103H138.5",
    stroke: "#24284E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10819_8333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M204.604 129.952C215.623 130.722 225.18 122.415 225.951 111.396C226.721 100.377 218.413 90.8199 207.395 90.0494C196.376 89.2789 186.819 97.5868 186.048 108.606C185.278 119.624 193.586 129.181 204.604 129.952Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206.259,
    cy: 100.766,
    r: 2.30769,
    transform: "rotate(4 206.259 100.766)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.844 105.853L204.02 105.236",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.02 105.236L200.44 112.311",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.554 105.344L201.975 112.419",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.44 112.311L207.539 112.807L203.794 119.485L206.672 119.686",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_10819_8333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7431 41.923C90.7468 40.9603 98.8866 31.2597 97.9239 20.256C96.9612 9.25236 87.2606 1.11255 76.2569 2.07524C65.2532 3.03794 57.1134 12.7386 58.0761 23.7423C59.0388 34.7459 68.7395 42.8857 79.7431 41.923Z",
    fill: "#FB6666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76.8125,
    cy: 12.8361,
    r: 2.30769,
    transform: "rotate(-5 76.8125 12.8361)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1113 16.8306L75.2988 17.6016",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2986 17.6029L72.8703 25.151",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8318 17.4682L74.4035 25.0162",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8711 25.1504L79.9595 24.5302L77.3061 31.7119L80.1796 31.4605",
    stroke: "#24284E",
    strokeWidth: 3.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_8333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    fill: "white",
    transform: "translate(83 26)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10819_8333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(187.443 88.6543) rotate(4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_10819_8333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(56.333 3.81836) rotate(-5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquatting);
export default __webpack_public_path__ + "static/media/squatting.61c6ddfdaaa720d04f8c836ae71162de.svg";
export { ForwardRef as ReactComponent };